//** Component  */
import React, { useEffect, useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import { Outlet } from 'react-router';
import { getAuthProps } from "./../utils/AuthenticationLibrary";
import ProtectedRoute from '../utils/AuthorizeNavigation/protectedRoute';

const Layout = (props) => {


  const [isSideBarOpen, setIsSideBarOpen] = useState(false);

  useEffect(() => {
    const authDetails = getAuthProps();
    let params = window.location.pathname;
    if (params === "/UnAuthorized") {
      window.location.href = "/UnAuthorizedg";
    }
    else if (!authDetails) {
      window.location.href = "/login";
    }
  });

  return (

    <div>
      {/* <div className={`layout-wrapper layout-content-navbar Drawer-Sidebar-highlighted `}> */}
      <div className={`layout-wrapper layout-content-navbar ${isSideBarOpen === true ? "sidebar-display-part" : ""}`}>
        <Sidebar componentRoutes={props.componentRoutes} handleIconClick={() => setIsSideBarOpen(!isSideBarOpen)} />
        <div className="layout-container ">
          <div className="content-wrapper containt-margin-200 laptop-width">
            {/* <AuthorizationWrap authorizeUserType={breadCrumbs[0].allowrole}> */}
            <Header componentRoutes={props.componentRoutes} handleIconClick={() => setIsSideBarOpen(!isSideBarOpen)} />
            <ProtectedRoute>
              <div className='container-xxl flex-grow-1 container-p-y pb-0'>
                <Outlet />
              </div>
            </ProtectedRoute>
            {/* </AuthorizationWrap> */}
          </div>
        </div>
      </div>
    </div>

  )
}

export default Layout;
